import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PredefinedTemplateComponent extends Component {
  static readonly TYPE_ID = 'd1528714772445329abc4b93b5939315';

  private constructor(
    public readonly uniqueId: string
  ) {
    super();
  }

  get $typeId(): string {
    return PredefinedTemplateComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static create({
    uniqueId,
  }: {
    uniqueId: string,
  }): PredefinedTemplateComponent {
    return new PredefinedTemplateComponent(uniqueId);
  }

  static fromMap(context: SerializationContext, map: SerializedData): PredefinedTemplateComponent {
    return PredefinedTemplateComponent.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
    };
  }

  clone(): this {
    return PredefinedTemplateComponent.create({
      uniqueId: this.uniqueId,
    }) as this;
  }

  isSame(other: this): boolean {
    return other.uniqueId === this.uniqueId;
  }
}

export class PredefinedTemplateIdComponentBuilder extends DataModelBuilder<PredefinedTemplateComponent> {
  build(context: SerializationContext, map: SerializedData): PredefinedTemplateComponent {
    return PredefinedTemplateComponent.fromMap(context, map);
  }
}
